import MuiRadio from '@mui/material/Radio'
import { alpha } from '@mui/material/styles'
import styled from '@emotion/styled'
import { RadioProps } from './Radio.types'

export const Radio = styled(MuiRadio)<Partial<RadioProps<string | number>>>`
  &.MuiRadio-root {
    padding: 8px;
    &:hover {
      background-color: ${({ theme, color = 'primary' }) => alpha(theme.palette[color].main, 0.2)};
    }
  }
  .MuiSvgIcon-root {
    font-size: 24px;
  }
`
